import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { some } from 'lodash';
import type { IMetaModel } from '../../../stores/model/metamodel';
import type { IDependency } from '../../../stores/model/metamodel/dependency';

/**
 * Check if the model has a duplicate dependency of the dependency under test.
 */
class DependencyDuplicateCheck extends Check<IDependency> {
  static description = 'Check for duplicate dependencies';

  constructor(model: IMetaModel, element: IDependency) {
    super(model, element);

    this.isDuplicate = this.isDuplicate.bind(this);
  }

  isDuplicate(dep: IDependency): boolean {
    return (
      dep !== this.element &&
      dep.master === this.element.master &&
      dep.dependent === this.element.dependent &&
      dep.name.master.toLowerCase() ===
        this.element.name.master.toLowerCase() &&
      dep.name.dependent.toLowerCase() ===
        this.element.name.dependent.toLowerCase()
    );
  }

  check(): Report {
    this.report = new Report();

    if (some(this.model.dependencies, this.isDuplicate)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Dependencies with the same master, dependent and name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No dependencies with the same master, dependent and name found.',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default DependencyDuplicateCheck;
